import React, { useEffect, useRef } from "react";
import "./Message.scss";
import { Link, useParams } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import newRequest from "../../utils/newRequest";

const Message = () => {
  const { id } = useParams();

  const endRef = useRef();

  // if we want to get the state from useLocation hook
  // const { sellerData } = location.state || {};

  const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  const queryClient = useQueryClient();

  const {
    isLoading: isLoadingMessages,
    error: errorMessages,
    data: dataMessages,
  } = useQuery({
    queryKey: ["messages"],
    queryFn: async () => {
      const messages = await newRequest
        .get(`/messages/${id}`)
        .then((res) => res.data);

      // Fetch user data for each message
      const users = await Promise.all(
        messages.map((message) =>
          newRequest.get(`/users/${message?.userId}`).then((res) => res.data)
        )
      );

      // Combine messages with user data
      return messages.map((message, index) => ({
        ...message,
        user: users[index],
      }));
    },
  });

  // Determine the other user in the conversation
  const otherUser = dataMessages?.find(
    (m) => m.userId !== currentUser._id
  )?.user;

  const mutation = useMutation({
    mutationFn: (message) => {
      return newRequest.post(`/messages`, message);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["messages"]);
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    mutation.mutate({
      conversationId: id,
      desc: e.target[0].value,
    });
    e.target[0].value = "";
  };

  //useRef to the end of message
  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [dataMessages]);

  return (
    <div className="message">
      <div className="message-container">
        <span className="breadcumbs">
          <Link className="link" to={"/messages"}>
            Messages
          </Link>
          {">"} {otherUser?.username || "Loading..."} {">"}
        </span>
        {isLoadingMessages ? (
          "loading"
        ) : errorMessages ? (
          `Error: ${errorMessages.message}`
        ) : (
          <div className="messages">
            {dataMessages.map((m) => (
              <div
                className={
                  m.userId === currentUser._id
                    ? "owner messages-item"
                    : "messages-item"
                }
                key={m._id}
              >
                <img src={m?.user?.img || "/img/noavatar.jpg"} alt="user_img" />
                <p>{m.desc}</p>
                <div ref={endRef}></div>
              </div>
            ))}
          </div>
        )}
        <hr />

        <form className="write" onSubmit={handleSubmit}>
          <textarea
            placeholder="Write a message"
            name=""
            id=""
            cols="30"
            rows="10"
          ></textarea>
          <button type="submit">Send</button>
        </form>
      </div>
    </div>
  );
};

export default Message;
